import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Input,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
// import "./style.css";
import CreateOffer from "./Create";
import EditCampaign from "./Edit";
import Approved from "./Approved";
import ReactTable from "components/ReactTable/ReactTable.js";
import actionCreators from "store/actionCreators/campaign";
import { connect } from "react-redux";
import { message, Pagination } from "antd";
import { useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { use } from "react";

const filterTabs = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

function Campaign(props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const offerId = searchParams.get("offerId");

  const [page, setPage] = React.useState("1");
  const [add, setAdd] = React.useState(false);
  const [item, setItem] = React.useState("");
  const [dataState, setDataState] = React.useState([]);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [itemsOnPage, setItemsOnPage] = React.useState(10);
  const [totalItems, setTotalItems] = React.useState("");
  const [name, setName] = React.useState("");

  const [approveOffer, setApproveOffer] = React.useState(false);
  const [isActive, setIsActive] = React.useState(true);

  const getFilterTabStyle = (active) => ({
    border: "none",
    borderBottom: active ? "2px solid #39b7b3" : "2px solid transparent",
    background: "transparent",
    color: active ? "#39b7b3" : "#b7b7c2",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "20px",
    padding: "0 14px 10px",
    cursor: "pointer",
    outline: "none",
  });

  useEffect(() => {
    if (offerId) {
      setPage("3");
      setItem({ offerId: offerId });
    }
  }, [offerId]);

  useEffect(() => {
    if (page == 1) {
      getList(pageNumber - 1);
    }
  }, [page]);

  useEffect(() => {
    setPageNumber(1);
    getList(0, name);
  }, [isActive]);

  const onKeyDown = (e) => {
    var theEvent = window.event || e;
    var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
    setPageNumber(0);
    if (code == 13) {
      if (e.target.value == "") {
        getList(page - 1);
      } else {
        getList(page - 1, e.target.value);
      }
    }
  };

  const getList = (page, search) => {
    let data = { pageNumber: page, itemsOnPage, search };
    console.log("isActive", isActive);
    props.getCampaigns(data, isActive).then((res) => {
      setItemsOnPage(res?.perPage);
      setTotalItems(res?.totalItems);
      let arr = res?.partnerCampaigns;
      if (arr) {
        // let dataState = arr.reverse().map((item, key) => {
        let dataState = arr.map((item, key) => {
          return {
            id: key,
            campaignName: item.title,
            userLimit: item.userLimit,
            startDate: item?.startDate?.split("T")[0],
            endDate: item?.endDate?.split("T")[0],
            status: item.isActive ? "Active" : "Inactive",
            qrCode: (
              <div
                className="flex items-center justify-center cursor-pointer"
                onClick={() => {
                  window.open(item.qrCodePresignedUrl, "_blank");
                }}
              >
                <img
                  className="ml-2 w-[15px]"
                  src={
                    require("../../../assets/img/er/Icon metro-qrcode.svg")
                      .default
                  }
                  alt=""
                />
              </div>
            ),
            partnerName: item?.partner?.businessName,
            partnerType: item?.partner?.partnerType,
            // actions: item.status==1?'Pending':'Pending',
            editActions: (
              // we've added some custom button actions
              <div key={key} className="actions-right">
                {/* use this button to add a edit kind of action */}
                <Button
                  onClick={() => {
                    setAdd(false);
                    setItem(item);
                    setPage("3");
                  }}
                  className="btn-icon btn-round"
                  color="warning"
                  size="sm"
                >
                  <i className="fa fa-edit" />
                </Button>
              </div>
            ),
            deleteActions: (
              <div key={key} className="actions-right">
                <Button
                  className="btn-icon btn-round"
                  color="warning"
                  onClick={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to Delete this offer?",
                      )
                    ) {
                      props.delCampaignById(item.id).then((res) => {
                        message.success("Campaign deleted");
                        getList();
                      });
                    }
                  }}
                  size="sm"
                >
                  <i className="fa fa-trash" />
                </Button>
              </div>
            ),
          };
        });
        // console.log(dataState);
        setDataState(dataState);
      }
    });
  };
  const onShowSizeChange = (page, pageSize) => {
    setPageNumber(page);
    getList(page - 1);
  };
  return (
    <>
      {item && (
        <Modal isOpen={approveOffer} toggle={() => setApproveOffer(false)}>
          {/* <ModalHeader toggle={() => setApproveOffer(false)}>
            {item.title}
          </ModalHeader> */}
          <ModalBody>
            <Approved
              offer={item}
              setPage={() => {
                setApproveOffer(false);
              }}
            />
          </ModalBody>
        </Modal>
      )}
      {page === "1" && (
        <div className="content users">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h5">
                    <div>Campaign Manager</div>
                  </CardTitle>
                  {/* <div className="float-right">
                    <Button
                      onClick={() => setPage("2")}
                      color="secondary"
                      size="md"
                      className="btn-round mr-2">
                      <i className="fa fa-plus mr-2" /> Create
                    </Button>
                  </div> */}
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col className="" md="12">
                      <FormGroup>
                        <Input
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          onKeyDown={onKeyDown}
                          placeholder="Search"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "15px",
                        marginBottom: "10px",
                        borderBottom: "1px solid #ececf3",
                      }}
                    >
                      {filterTabs.map((tab) => {
                        const active = isActive === tab.value;

                        return (
                          <button
                            key={tab.label}
                            type="button"
                            style={getFilterTabStyle(active)}
                            onClick={() => {
                              if (isActive !== tab.value) {
                                setIsActive(tab.value);
                              }
                            }}
                          >
                            {tab.label}
                          </button>
                        );
                      })}
                    </div>
                  </Row>

                  {/* campaignName
                  userLimit
                  startDate
                  endDate
                  status
                  qrCode */}
                  <ReactTable
                    data={dataState}
                    columns={[
                      {
                        Header: "Campaign Name",
                        accessor: "campaignName",
                        sortable: false,
                        minWidth: 250,
                        width: 300,
                      },
                      {
                        Header: "User Limit",
                        accessor: "userLimit",
                        sortable: false,
                      },
                      {
                        Header: "Start Date",
                        accessor: "startDate",
                        sortable: false,
                        filterable: false,
                      },
                      {
                        Header: "End Date",
                        accessor: "endDate",
                        sortable: false,
                        filterable: false,
                      },
                      {
                        Header: "Status",
                        accessor: "status",
                        sortable: false,
                        filterable: false,
                      },
                      {
                        Header: "QR Code",
                        accessor: "qrCode",
                        sortable: false,
                        filterable: false,
                      },

                      {
                        Header: "Partner Name",
                        accessor: "partnerName",
                        sortable: false,
                        filterable: false,
                        minWidth: 200,
                        width: 240,
                      },

                      {
                        Header: "Partner Type",
                        accessor: "partnerType",
                        sortable: false,
                        filterable: false,
                      },

                      {
                        Header: (
                          <div style={{ width: "100%", textAlign: "right" }}>
                            Edit
                          </div>
                        ),
                        accessor: "editActions",
                        sortable: false,
                        filterable: false,
                      },
                      {
                        Header: "Delete",
                        accessor: "deleteActions",
                        sortable: false,
                        filterable: false,
                      },
                    ]}
                  />
                  <Row>
                    <Col md="12">
                      <div className="erPagination">
                        <Pagination
                          showSizeChanger={false}
                          current={pageNumber}
                          defaultPageSize={itemsOnPage}
                          pageSize={itemsOnPage}
                          total={totalItems}
                          onChange={onShowSizeChange}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      )}
      {/* {page === "2" && <CreateOffer setPage={setPage} />} */}
      {page === "3" && (
        <EditCampaign
          setPage={setPage}
          onApprove={() => setApproveOffer(true)}
          item={item}
        />
      )}
    </>
  );
}

function mapStateToProps(state) {
  return state.user;
}
export default connect(mapStateToProps, actionCreators)(Campaign);
